/**
 * @fileoverview Agent definition for character-continuity-checker-v2.
 *
 * This agent analyzes a chapter specifically for character continuity errors,
 * checking behaviors, knowledge, dialogue, and physical descriptions.
 *
 * @category narrative.prose.continuity
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'character-continuity-checker-v2',
  kind: 'primitive',
  name: 'Character Continuity Checker',
  description: 'Analyzes chapter content for contradictions with established character behaviors, knowledge, and descriptions.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.continuity',
    usedBy: [
      'use-character-continuity-checker-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'chapter-continuity-checker-v2',
    ],
  },
};
